import state from './itemState'
import mutations from './itemMutations'
import actions from './itemActions'
import getters from './itemGetters'

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
